export function getBedbankMemberTotalIncludingPropertyFees(rate: App.BedbankRate): number | undefined {
  const { memberInclusive, memberTotal, propertyFees } = rate.totals

  if (memberTotal != null) {
    return memberTotal
  }

  if (memberInclusive == null) {
    return undefined
  }

  return memberInclusive + (propertyFees ?? 0)
}
